// 9fbef606107a605d69c0edbcd8029e5d

export const GLOBAL_ERROR_MESSAGES_LABELS = 'global.errorMessages';

export const globalErrorMessagesLabels = {
  global: {
    errorMessages: {
      lbl_errorMessages_INTERNAL_SERVER_ERROR: 'Oops... There was an issue, please try again.',
      lbl_errorMessages_DEFAULT:
        'Oh no! Something went wrong... Please try again in a few minutes.',
    },
  },
};
